import configuration from '../config/config';

const APIENDPOINTS = {
	PORTAL_USER_INFO: `${configuration?.api.PORTAL_DOMAIN}/v1/identity/user-context`,

	DS_URL: `${configuration?.api.DS_DOMAIN}`,
	CP_PROFILE_URL: `${configuration?.api.CP_PROFILE_DOMAIN}`,
	CP_FINDINGS_URL: `${configuration?.api.CP_FINDINGS_DOMAIN}`,

	// Micro Services
	PERFORMANCE_URL: `${configuration?.api.CP_PERFORMANCE}`,
	TREND_URL: `${configuration?.api.CP_TREND}`,
	GRID_URL: `${configuration?.api.CP_GRID}`,
	SEARCH_URL: `${configuration?.api.SEARCH}`,
	BREAKDOWN_URL: `${configuration?.api.BREAKDOWN}`,
	SUMMARY_URL: `${configuration?.api.SUMMARY}`,
	MAP_SUMMARY_URL: `${configuration?.api.MAP_SUMMARY}`,
	CUSTOM_RULE_URL: `${configuration?.api.CUSTOM_RULE}`,
	EVENT_TRACK_URL: `${configuration?.api.EVENT_TRACK}`,
	INTELLIGENT_FEEDBACK_URL: `${configuration?.api.INTELLIFGENT_FEEDBACK}`,
	USER_PREF_URL: `${configuration?.api.USER_PREF}`,
	TABLE_GRAPHQL: `${configuration?.api.TABLE_GRAPHQL}`,
	METRICS: `${configuration?.api.METRICS}`,
	METRICS_ECOM: `${configuration?.api.METRICS_ECOM}`,
	METRICS_STORE: `${configuration?.api.METRICS_STORE}`,
	GET_PREFERENCES: `${configuration?.api.GET_PREFERENCES}`,
	GET_PREFERENCES_ECOM: `${configuration?.api.GET_PREFERENCES}&channel=ECOM`,
	GET_PREFERENCES_STORE: `${configuration?.api.GET_PREFERENCES}&channel=STORE`,
	SAVE_PREFERENCES: `${configuration?.api.SAVE_PREFERENCES}`,
	DOWNLOAD_IN_EXCEL: `${configuration?.api.DOWNLOAD_IN_EXCEL}`,
	DATA_REFRESH: `${configuration?.api.DATA_REFRESH}`,
	GET_USER_AUTH: `${configuration?.api.USER_AUTH}`,
	AD_GRAPHQL: `${configuration?.api.AD_GRAPHQL}`,
	GRAPHQL: `${configuration?.api.GRAPHQL}`,
};

export default APIENDPOINTS;
